import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import authService from "../Services/auth";
import Swal from "sweetalert2";
import { handleApiError } from "../Helpers/handleApiError ";
import { handleApiSuccess } from "../Helpers/handleApiSuccess ";
import { useNavigate } from "react-router-dom";
import Carousel from "./Carousel";
import img1 from "../../src/SliderImage/1.jpg";
import img3 from "../../src/SliderImage/3.jpg";
import img4 from "../../src/SliderImage/4.jpg";
import img5 from "../../src/SliderImage/5.jpg";
import img6 from "../../src/SliderImage/6.jpg"; 
import img7 from "../../src/SliderImage/7.jpg";
import img8 from "../../src/SliderImage/8.jpg";
import grohe from "../../src/clientlogo/index_grohe_logo.jpg";
import americanStandard from "../../src/clientlogo/index_as_logo.gif";
import lixil from "../../src/clientlogo/index_lixil_logo.gif";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const images = [img1, img3, img4, img5, img6, img7, img8];
  const clientLogos = [
    { src: grohe, alt: "Grohe" },
    { src: americanStandard, alt: "American Standard" },
    { src: lixil, alt: "Lixil" },
  ];

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await authService.authlogin({ email, password });
      if (
        response.status &&
        response.data.data.role_id == 1 &&
        response.data.data.is_active == 1
      ) {
        handleApiSuccess(response.message, "Success");
        localStorage.setItem("u_token", response.data.token);
        localStorage.setItem("role_code", response.data.data.role_id);
        // window.location.href = "/admin/home";
      } else {
        Swal.fire("Permission Denied", "You do not have the right access.", "warning");
      }
    } catch (error) {
      handleApiError(error, "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const token_check = localStorage.getItem("u_token");
  const role_check = Number(localStorage.getItem("role_code"));

  useEffect(() => {
    if (token_check) {
      if (role_check == 1) {
        window.location.href = "/admin/home";
      } else{
        // console.log(4,'=>')
        console.log('INALID USER');
      }
    }
  }, [token_check, role_check]);

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden bg-[#050b14] font-['Inter',system-ui,sans-serif]">
      {/* Background Carousel with Dark Elegant Overlay */}
      <div className="absolute inset-0 z-0">
        <Carousel images={images} />
        <div className="absolute inset-0 bg-gradient-to-br from-[#020617]/95 via-[#0f172a]/80 to-[#020617]/95 pointer-events-none mix-blend-multiply"></div>
      </div>

      {/* Top Left Logos (Corporate Watermark Style) */}
      <div className="absolute top-8 left-8 z-20 flex flex-col gap-4">
        <div className="flex gap-4 items-center bg-white/5 backdrop-blur-xl p-3.5 rounded-2xl border border-white/10 shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
          {clientLogos.slice(0, 2).map((logo, index) => (
            <div key={index} className="px-4 py-1.5 bg-white/10 hover:bg-white/15 transition duration-300 rounded-xl flex items-center justify-center">
              <img src={logo.src} alt={logo.alt} className="w-20 h-10 object-contain drop-shadow-md" />
            </div>
          ))}
        </div>
        <div className="flex items-center pl-3 opacity-90">
          <span className="text-slate-300 text-xs font-semibold tracking-[0.2em] mr-4">PART OF</span>
          <span className="bg-gradient-to-r from-orange-500 to-amber-500 text-white px-2.5 py-0.5 rounded text-[10px] font-black tracking-widest shadow-[0_0_15px_rgba(249,115,22,0.4)]">LIXIL</span>
        </div>
      </div>

      {/* Login Card */}
      <div className="w-[90%] sm:w-[440px] relative z-10 group">
        {/* Subtle glowing orb behind the card */}
        <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500/20 to-emerald-500/20 blur-2xl rounded-[2.5rem] opacity-70 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 pointer-events-none"></div>
        
        <div className="relative bg-[#0b1320]/60 backdrop-blur-3xl border border-white/10 rounded-3xl shadow-[0_8px_32px_0_rgba(0,0,0,0.6)] p-12 overflow-hidden">
          {/* Glass highlight edge */}
          <div className="absolute top-0 inset-x-0 h-[1px] bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>

          <div className="text-center mb-10">
            <h2 className="text-3xl font-light text-white tracking-tight mb-3">Admin <span className="font-semibold text-emerald-400">Portal</span></h2>
            <p className="text-slate-400 text-sm tracking-wide">Enter your credentials to access the dashboard</p>
          </div>
          
          <form onSubmit={handleLogin} className="space-y-6">
            <div className="relative group/input">
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                id="email"
                name="email"
                type="email"
                required
                className="peer w-full px-4 pt-7 pb-2.5 text-sm rounded-xl bg-black/30 border border-white/10 focus:border-emerald-500/50 focus:bg-black/50 focus:ring-1 focus:ring-emerald-500/50 text-white outline-none transition-all duration-300 shadow-inner"
                placeholder=" "
              />
              <label 
                htmlFor="email" 
                className="absolute left-4 top-4.5 text-slate-400 text-sm transition-all duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:text-sm peer-placeholder-shown:text-slate-500 peer-focus:-translate-y-3 peer-focus:text-[11px] peer-focus:text-emerald-400 peer-focus:font-medium peer-valid:-translate-y-3 peer-valid:text-[11px]"
                style={{ top: '18px' }}
              >
                Email Address
              </label>
            </div>

            <div className="relative group/input">
              <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                id="password"
                name="password"
                type="password"
                required
                className="peer w-full px-4 pt-7 pb-2.5 text-sm rounded-xl bg-black/30 border border-white/10 focus:border-emerald-500/50 focus:bg-black/50 focus:ring-1 focus:ring-emerald-500/50 text-white outline-none transition-all duration-300 shadow-inner"
                placeholder=" "
              />
              <label 
                htmlFor="password" 
                className="absolute left-4 top-4.5 text-slate-400 text-sm transition-all duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:text-sm peer-placeholder-shown:text-slate-500 peer-focus:-translate-y-3 peer-focus:text-[11px] peer-focus:text-emerald-400 peer-focus:font-medium peer-valid:-translate-y-3 peer-valid:text-[11px]"
                style={{ top: '18px' }}
              >
                Password
              </label>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="group/btn relative w-full py-4 mt-6 bg-gradient-to-r from-emerald-600 to-teal-500 hover:from-emerald-500 hover:to-teal-400 text-white font-medium tracking-wide rounded-xl shadow-[0_0_20px_rgba(16,185,129,0.2)] hover:shadow-[0_0_30px_rgba(16,185,129,0.4)] transition-all duration-300 transform hover:-translate-y-0.5 overflow-hidden disabled:opacity-70 disabled:hover:translate-y-0"
            >
              <span className="relative z-10 flex items-center justify-center gap-2">
                {loading ? (
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                ) : 'Secure Sign In'}
              </span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover/btn:translate-y-0 transition-transform duration-300 ease-in-out"></div>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}